import { classNames } from '../../utils/classNames';
import { AceTag, IAceTag } from '../AceTag';
import styles from './StatusTag.module.css';
import {
  loan_application,
  loan_quote,
  loan_request,
} from '@axo/shared/data-access/types';

export interface IStatusTag extends IAceTag {
  status: string;
}

// eslint-disable-next-line react-refresh/only-export-components
export const statusClassByName: { [key: string]: string } = {
  [loan_application.ApplicationStatus
    .ApplicationStatusPendingReceiptCustomerInputComplete]: styles.blue,
  [loan_application.ApplicationStatus
    .ApplicationStatusPendingReceiptFetchingExternalData]: styles.blue,
  [loan_application.ApplicationStatus
    .ApplicationStatusWithdrawnByCustomerIncomplete]: styles.rose,
  [loan_application.ApplicationStatus
    .ApplicationStatusApplicationReviewManualAdjustment]: styles.blue,
  [loan_application.ApplicationStatus
    .ApplicationStatusApplicationReviewAutomaticAdjustment]: styles.blue,
  [loan_application.ApplicationStatus
    .ApplicationStatusPendingRegistrationWithBanks]: styles.blue,
  [loan_application.ApplicationStatus
    .ApplicationStatusOfferAcceptedWithdrawnByCustomer]: styles.gray,
  [loan_application.ApplicationStatus
    .ApplicationStatusNotRegisteredWithAnyBank]: styles.rose,
  [loan_application.ApplicationStatus.ApplicationStatusCompletedCancelledByAxo]:
    styles.rose,
  [loan_application.ApplicationStatus
    .ApplicationStatusCompletedWithdrawnByCustomer]: styles.rose,
  [loan_application.ApplicationStatus.ApplicationStatusPendingBankApproval]:
    styles.blue,
  [loan_application.ApplicationStatus
    .ApplicationStatusRegisteredCancelledByAxo]: styles.rose,
  [loan_application.ApplicationStatus
    .ApplicationStatusRegisteredWithdrawnByCustomer]: styles.rose,
  [loan_application.ApplicationStatus.ApplicationStatusPendingCustomerAccept]:
    styles.blue,
  [loan_application.ApplicationStatus.ApplicationStatusNotAcceptedByCustomer]:
    styles.red,
  [loan_application.ApplicationStatus.ApplicationStatusApprovedCancelledByAxo]:
    styles.rose,
  [loan_application.ApplicationStatus
    .ApplicationStatusApprovedWithdrawnByCustomer]: styles.rose,
  [loan_application.ApplicationStatus
    .ApplicationStatusPendingBankApprovalForDisbursement]: styles.blue,
  [loan_application.ApplicationStatus
    .ApplicationStatusNotApprovedForDisbursementByAnyBank]: styles.vermilion,
  [loan_application.ApplicationStatus
    .ApplicationStatusOfferAcceptedCancelledByAxo]: styles.rose,
  [loan_application.ApplicationStatus.ApplicationStatusPendingDisbursement]:
    styles.blue,
  [loan_application.ApplicationStatus.ApplicationStatusNotDisbursedByAnyBank]:
    styles.orange,
  [loan_application.ApplicationStatus
    .ApplicationStatusDisbursementCancelledByAxo]: styles.rose,
  [loan_application.ApplicationStatus
    .ApplicationStatusDisbursementWithdrawnByCustomer]: styles.rose,
  [loan_application.ApplicationStatus.ApplicationStatusLoanDisbursed]:
    styles.turquoise,
  [loan_application.ApplicationStatus.ApplicationStatusCloned]: styles.cobalt,

  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedPendingRegistration]: styles.gray,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedDownsellAdjustment]: styles.gray,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedUpsellAdjustment]: styles.gray,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedPendingRegistrationOther]:
    styles.gray,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedRegistered]: styles.lime,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedNotRegistered]: styles.rose,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedNotRegisteredPIDError]: styles.black,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedNotRegisteredAddressError]:
    styles.black,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedNotRegisteredBankError]: styles.black,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedNotRegisteredCreditScore]:
    styles.rose,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedNotRegisteredBankDisabled]:
    styles.rose,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedNotRegisteredBankFilter]: styles.rose,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedNotRegisteredBankFilterCoApplicant]:
    styles.rose,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedNotRegisteredOther]: styles.rose,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedCancelledByAxo]: styles.rose,
  [loan_request.LoanRequestStatus
    .LoanRequestStatusApplicationCompletedWithdrawnByAxo]: styles.gray,

  [loan_quote.LoanQuoteStatus.ApplicationRegisteredPendingBankDecision]:
    styles.gray,
  [loan_quote.LoanQuoteStatus
    .ApplicationRegisteredPendingBankDecisionValidation]: styles.gray,
  [loan_quote.LoanQuoteStatus
    .ApplicationRegisteredPendingBankDecisionFormSubmit]: styles.gray,
  [loan_quote.LoanQuoteStatus
    .ApplicationRegisteredPendingBankDecisionTaxConsent]: styles.gray,
  [loan_quote.LoanQuoteStatus
    .ApplicationRegisteredPendingBankDecisionPSD2Consent]: styles.gray,
  [loan_quote.LoanQuoteStatus
    .ApplicationRegisteredPendingBankDecisionDocuments]: styles.gray,
  [loan_quote.LoanQuoteStatus
    .ApplicationRegisteredPendingBankDecisionInformation]: styles.gray,
  [loan_quote.LoanQuoteStatus
    .ApplicationRegisteredPendingBankDecisionCoApplicant]: styles.gray,
  [loan_quote.LoanQuoteStatus
    .ApplicationRegisteredPendingBankDecisionSignature]: styles.gray,
  [loan_quote.LoanQuoteStatus
    .ApplicationRegisteredPendingBankDecisionSlowResponse]: styles.gray,
  [loan_quote.LoanQuoteStatus.ApplicationRegisteredPendingBankDecisionBank]:
    styles.gray,
  [loan_quote.LoanQuoteStatus.ApplicationRegisteredApprovedByBank]: styles.lime,
  [loan_quote.LoanQuoteStatus.ApplicationRegisteredNotApprovedByBank]:
    styles.vermilion,
  [loan_quote.LoanQuoteStatus.ApplicationRegisteredNotApprovedByBankDuplicate]:
    styles.indigo,
  [loan_quote.LoanQuoteStatus.ApplicationRegisteredNotApprovedByBankReRegister]:
    styles.vermilion,
  [loan_quote.LoanQuoteStatus
    .ApplicationRegisteredNotApprovedByBankAddCoApplicant]: styles.vermilion,
  [loan_quote.LoanQuoteStatus.ApplicationRegisteredNotApprovedByBankOther]:
    styles.vermilion,
  [loan_quote.LoanQuoteStatus.ApplicationRegisteredCancelledByAxo]: styles.rose,
  [loan_quote.LoanQuoteStatus.ApplicationRegisteredCancelledByBank]:
    styles.rose,
  [loan_quote.LoanQuoteStatus
    .ApplicationRegisteredCancelledByAxoOnCustomerBehalf]: styles.rose,
  [loan_quote.LoanQuoteStatus
    .ApplicationRegisteredCancelledByBankOnCustomerBehalf]: styles.rose,
  [loan_quote.LoanQuoteStatus.ApplicationRegisteredCancelledByAxoCancelFailed]:
    styles.black,
  [loan_quote.LoanQuoteStatus.ApplicationRegisteredWithdrawnByAxo]: styles.rose,
  [loan_quote.LoanQuoteStatus.ApplicationRegisteredExpired]: styles.rose,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedPendingCustomerDecision]:
    styles.lime,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedPendingCustomerDecisionOther]:
    styles.lime,
  [loan_quote.LoanQuoteStatus
    .ApplicationApprovedPendingCustomerDecisionAcceptFailed]: styles.black,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedAcceptedByCustomer]:
    styles.blue,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedAcceptedByAxo]: styles.blue,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedNotAcceptedByCustomer]:
    styles.red,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedNotAcceptedByAxo]: styles.red,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedNotAcceptedByCustomerOther]:
    styles.red,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedNotAcceptedByAxoOther]:
    styles.red,
  [loan_quote.LoanQuoteStatus
    .ApplicationApprovedCancelledByAxoOnCustomerBehalf]: styles.rose,
  [loan_quote.LoanQuoteStatus
    .ApplicationApprovedCancelledByBankOnCustomerBehalf]: styles.rose,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedCancelledByAxo]: styles.rose,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedCancelledByBank]: styles.rose,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedRejectedByBank]:
    styles.vermilion,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedWithdrawnByAxo]: styles.rose,
  [loan_quote.LoanQuoteStatus.ApplicationApprovedExpired]: styles.rose,
  [loan_quote.LoanQuoteStatus.OfferAcceptedPendingBankDisbursementDecision]:
    styles.blue,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedPendingBankDisbursementDecisionValidation]: styles.blue,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedPendingBankDisbursementDecisionFormSubmit]: styles.blue,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedPendingBankDisbursementDecisionTaxConsent]: styles.blue,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedPendingBankDisbursementDecisionPSD2Consent]: styles.blue,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedPendingBankDisbursementDecisionDocuments]: styles.blue,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedPendingBankDisbursementDecisionInformation]: styles.blue,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedPendingBankDisbursementDecisionCoApplicant]: styles.blue,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedPendingBankDisbursementDecisionSignature]: styles.blue,
  [loan_quote.LoanQuoteStatus.OfferAcceptedPendingBankDisbursementDecisionBank]:
    styles.blue,
  [loan_quote.LoanQuoteStatus.OfferAcceptedApprovedForDisbursementByBank]:
    styles.turquoise,
  [loan_quote.LoanQuoteStatus.OfferAcceptedNotApprovedForDisbursementByBank]:
    styles.vermilion,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedNotApprovedForDisbursementByBankDuplicate]: styles.indigo,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedNotApprovedForDisbursementByBankReRegister]: styles.vermilion,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedNotApprovedForDisbursementByBankAddCoApplicant]:
    styles.vermilion,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedNotApprovedForDisbursementByBankOther]: styles.vermilion,
  [loan_quote.LoanQuoteStatus.OfferAcceptedCancelledByAxo]: styles.rose,
  [loan_quote.LoanQuoteStatus.OfferAcceptedCancelledByBank]: styles.rose,
  [loan_quote.LoanQuoteStatus.OfferAcceptedCancelledByBankOnCustomerBehalf]:
    styles.rose,
  [loan_quote.LoanQuoteStatus.OfferAcceptedCancelledByAxoOnCustomerBehalf]:
    styles.rose,
  [loan_quote.LoanQuoteStatus.OfferAcceptedWithdrawnByAxo]: styles.rose,
  [loan_quote.LoanQuoteStatus.OfferAcceptedExpired]: styles.rose,
  [loan_quote.LoanQuoteStatus
    .OfferAcceptedPendingBankDisbursementDecisionReAcceptFailed]: styles.black,
  [loan_quote.LoanQuoteStatus.LoanApprovedForDisbursementPendingDisbursement]:
    styles.blue,
  [loan_quote.LoanQuoteStatus
    .LoanApprovedForDisbursementPendingDisbursementOther]: styles.blue,
  [loan_quote.LoanQuoteStatus.LoanApprovedForDisbursementDisbursedByBank]:
    styles.turquoise,
  [loan_quote.LoanQuoteStatus.LoanApprovedForDisbursementNotDisbursedByBank]:
    styles.vermilion,
  [loan_quote.LoanQuoteStatus.LoanApprovedForDisbursementCancelledByAxo]:
    styles.rose,
  [loan_quote.LoanQuoteStatus.LoanApprovedForDisbursementCancelledByBank]:
    styles.rose,
  [loan_quote.LoanQuoteStatus
    .LoanApprovedForDisbursementCancelledByAxoOnCustomerBehalf]: styles.rose,
  [loan_quote.LoanQuoteStatus
    .LoanApprovedForDisbursementCancelledByBankOnCustomerBehalf]: styles.rose,
  [loan_quote.LoanQuoteStatus
    .LoanApprovedForDisbursementCancelledByAxoCancelFailed]: styles.black,
  [loan_quote.LoanQuoteStatus.LoanApprovedForDisbursementWithdrawnByAxo]:
    styles.rose,
};

export function StatusTag({ status, ...props }: IStatusTag) {
  return (
    <AceTag
      {...props}
      classes={{
        root: classNames(styles.tag, props.classes?.root),
        tag: classNames(statusClassByName[status], props.classes?.tag),
      }}
    >
      {props.children}
    </AceTag>
  );
}
